<template>
    <div class="aba-cliente">
        <container-loader v-if="isLoading && !$store.getters.isLoading" />
        <div class="vertical-flow">
            <div class="columns">
                <!-- CAIXA DE BUSCA -->
                <div
                    class="column"
                    :class="[
                        permissaoVincular && permissaoCadastrar
                            ? 'is-4'
                            : permissaoVincular || permissaoCadastrar
                            ? 'is-6'
                            : 'is-8',
                    ]"
                >
                    <search-bar
                        :onSearch="debouncedOnSearch"
                        tooltipLabel="msg-campo-busca-forma-recebimento"
                    />
                </div>

                <!-- SELEÇÃO DE SITUAÇÃO -->
                <div
                    class="column"
                    :class="[
                        permissaoVincular && permissaoCadastrar
                            ? 'is-2'
                            : permissaoVincular || permissaoCadastrar
                            ? 'is-3'
                            : 'is-4',
                    ]"
                >
                    <vss-select
                        ref="situacaoSelect"
                        :searchable="false"
                        :options="situacaoSelect"
                        v-model="situacaoSelected"
                        mlLabels
                        title="situacao"
                        clearable
                        @input="onSituacaoChanged"
                        :height="40"
                    />
                </div>

                <!-- BOTÃO DE VÍNCULO -->
                <div class="column is-3" v-if="permissaoVincular">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="showModalFormaRecebimentoNaoAssociados"
                    >
                        {{ $t('vincular-forma-recebimento') }}
                    </button>
                </div>

                <!-- BOTÃO DE CADASTRO -->
                <div class="column is-3" v-if="permissaoCadastrar">
                    <button class="save-btn botao-acao" type="button" @click="showModalCadastro">
                        {{ $t('adicionar-forma-recebimento') }}
                    </button>
                </div>
            </div>

            <!-- LISTAGEM -->
            <div class="registry-wrapper">
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="assformarecebimentocliente"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="f.key != 'excluir' ? $t(f.key) : ''"
                        :width="f.width"
                        :class="{
                            'excluir-field': f.key == 'excluir',
                        }"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                        v-slot="props"
                    >
                        <!-- COLUNA DE DESATIVAÇÃO/REATIVAÇÃO -->
                        <div v-if="f.key == 'excluir'">
                            <b-button
                                v-if="permissao.update && !assFormaRecebimentoClienteIntegracao"
                                class="action-button"
                                :type="
                                    props.row['replicapda'] == 3
                                        ? 'is-danger'
                                        : 'is-success'
                                "
                                :icon-right="
                                    props.row['replicapda'] == 3 ? 'delete' : 'check'
                                "
                                @click="promptChangeSituacao(props.row)"
                                v-tippy 
                                :title="$t(props.row['replicapda'] == 3 ? 'desativar' : 'reativar')"
                            />
                        </div>

                        <!-- COLUNA DE DATA -->
                        <div v-else-if="f.key == 'data-hora'">
                            {{ props.row[f.key] | moment('DD/MM/YYYY HH:mm:ss') }}
                        </div>

                        <!-- COLUNA DE SITUAÇÃO -->
                        <div v-else-if="f.key == 'replicapda'">
                            <b-tag
                                class="table-tag table-tag-full-width"
                                :type="props.row['replicapda'] == 3 ? 'is-success' : 'is-danger'"
                                size="is-medium"
                            >
                                {{ $t(props.row['replicapda'] == 3 ? 'ativo' : 'inativo') }}
                            </b-tag>
                        </div>
                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                </b-table>

                <!-- PAGINAÇÃO -->
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>

            <!-- MODAL DE ASSOCIACAO -->
            <b-modal :active.sync="showModalAssociacao">
                <div class="bg">
                    <FormaRecebimentoModal
                        :idCliente="$route.params.id"
                        @fecharModal="fecharModal"
                    />
                </div>
            </b-modal>

            <!-- MODAL DE CADASTRO DE FORMA DE RECEBIMENTO -->
            <b-modal :active.sync="showModalCadastroForma">
                <div>
                    <FormaRecebimentoCadastroModal
                        @cadastrado="cadastrado"
                        :idCliente="$route.params.id"
                        :permissaoVincular="!assFormaRecebimentoClienteIntegracao"
                        @fecharModal="closeModalCadastro"
                    />
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
// SERVICES
import AssFormaRecebimentoClienteService from '@/services/vendas/cliente/abas/AssFormaRecebimentoClienteService';
import FormaRecebimentoModal from '@/components/vendas/cliente/modal/FormaRecebimentoModal.vue';
import FormaRecebimentoCadastroModal from '@/components/vendas/cliente/modal/FormaRecebimentoCadastroModal.vue';

// COMPONENTS
import ContainerLoader from '@/components/content/loader/ContainerLoader';

export default {
    components: {
        ContainerLoader,
        FormaRecebimentoModal,
        FormaRecebimentoCadastroModal,
    },
    data() {
        return {
            assFormaRecebimentoClienteIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'ASSFORMARECEBIMENTOCLIENTE'
            ),
            formaRecebimentoIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'FORMARECEBIMENTO'
            ),
            assformarecebimentocliente: [],
            fields: [
                { key: 'codigo', width: null, sortable: true, sortFn: null },
                { key: 'forma-recebimento', width: null, sortable: true, sortFn: null },
                { key: 'data-hora', width: null, sortable: false, sortFn: null },
                { key: 'replicapda', width: 80, sortable: true, sortFn: null },
                { key: 'excluir', width: 20, sortable: false, sortFn: null },
            ],
            service: new AssFormaRecebimentoClienteService(this.$http, this.$router),
            permissao: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            situacaoSelected: { id: 4, label: 'todos' },
            situacaoSelect: [
                { id: 4, label: 'todos' },
                { id: 3, label: 'ativos' },
                { id: 2, label: 'inativos' },
            ],
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            queryFilter: '',
            column: 'forma-recebimento',
            order: 'asc',
            isSaving: false,
            delete: null,
            showModalAssociacao: false,
            showModalCadastroForma: false,
            permissaoCadastroFormaRecebimento: false,

            //permissoes relativas à exibição dos botões
            permissaoVincular: false,
            permissaoCadastrar: false,

            isVenda: this.$route.meta.contexto == 'vendas',
            isAgro: this.$route.meta.contexto == 'agro',
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        if (this.isVenda) {
            this.permissao = this.hasPermissionAccess(
                'vendas',
                'clientes',
                'ven-cliente-politica-comercial-forma-recebimento'
            );
        } else if (this.isAgro) {
            this.abrev = this.$route.meta.contexto.slice(0, 4);
            this.permissao = this.hasPermissionAccess(
                'agro',
                'clientes',
                'agro-cliente-politica-comercial-forma-recebimento'
            );
        }

        if (this.isVenda) {
            this.permissaoCadastroFormaRecebimento = this.hasPermissionAccess(
                'vendas',
                'clientes',
                'ven-forma-recebimento'
            );
        } else if (this.isAgro) {
            this.abrev = this.$route.meta.contexto.slice(0, 4);
            this.permissaoCadastroFormaRecebimento = this.hasPermissionAccess(
                'agro',
                'clientes',
                'agro-forma-recebimento'
            );
        }

        // variáveis que definem as permissões com base nas permissões da tela e dos dados que vêm do ERP
        this.permissaoVincular =
            this.permissao.create && !this.assFormaRecebimentoClienteIntegracao;
        this.permissaoCadastrar =
            this.permissaoCadastroFormaRecebimento.create && !this.formaRecebimentoIntegracao;

        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'clientes' },
            });
        } else {
            this.carregarDados();
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        }
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-forma-recebimento-' + numberId;
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;

            this.findAll(
                this.column,
                this.order,
                currentPage - 1,
                this.pagination.perPage,
                this.situacaoSelected.id,
                this.$route.params.id,
                this.queryFilter
            )
                .then(this.mapItems)
                .then((value) => {
                    this.assformarecebimentocliente = value;
                    this.isEmpty = this.assformarecebimentocliente.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar as tabelas de forma de recebimento.');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        findAll(column, order, page, limit, situacao, idcliente, ...params) {
            if (this.isVenda) {
                return this.service.findAllVendas(
                    column,
                    order,
                    page,
                    limit,
                    situacao,
                    idcliente,
                    ...params
                );
            } else {
                return this.service.findAllAgro(
                    column,
                    order,
                    page,
                    limit,
                    situacao,
                    idcliente,
                    ...params
                );
            }
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((m) => {
                return {
                    idassformarecebimentocliente: m.idassformarecebimentocliente,
                    codigo: m.formarecebimento.idformarecebimentoerp,
                    idformarecebimento: m.formarecebimento.idformarecebimento,
                    'forma-recebimento': m.formarecebimento.descricao,
                    'data-hora': m.datahorainc,
                    replicapda: m.replicapda,
                };
            });
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSituacaoChanged(val) {
            this.situacaoSelected = val
                ? this.situacaoSelect.filter((v) => v.id == val.id)[0]
                : this.situacaoSelect[0];
            this.carregarDados();
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.replicapda == 3
                        ? 'msg-confirmacao-desativacao-n'
                        : 'msg-confirmacao-reativacao-n', 
                    { n: row['forma-recebimento'] }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure =
                this.delete.replicapda == 3
                    ? 'msg-erro-ao-desativar-associacao-forma-recebimento'
                    : 'msg-erro-ao-reativar-associacao-forma-recebimento';

            let tempAssformarecebimentocliente = {
                idassformarecebimentocliente: this.delete.idassformarecebimentocliente,
                replicapda: this.delete.replicapda == 3 ? 2 : 3,
            };

            this.isLoading = true;

            this.updateSituacao(tempAssformarecebimentocliente)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess =
                            r.content.replicapda == 3
                                ? 'msg-sucesso-ao-reativar-associacao-forma-recebimento'
                                : 'msg-sucesso-ao-desativar-associacao-forma-recebimento';
                        this.$root.showMessage('success', tempSuccess);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);
                    this.$root.showMessage('error', tempFailure);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        updateSituacao(assformarecebimentocliente) {
            if (this.isVenda) return this.service.updateSituacaoVendas(assformarecebimentocliente);
            else return this.service.updateSituacaoAgro(assformarecebimentocliente);
        },
        redirect(name) {
            setTimeout(() => {
                this.$router.push(
                    {
                        name: name,
                        query: {
                            tela: 'cliente-usuario',
                            'id-cliente': this.$route.params.id,
                        },
                    },
                    1000
                );
            });
        },
        showModalFormaRecebimentoNaoAssociados() {
            this.showModalAssociacao = !this.showModalAssociacao;
        },
        showModalCadastro() {
            this.showModalCadastroForma = !this.showModalCadastroForma;
        },
        fecharModal() {
            this.showModalAssociacao = false;
            this.carregarDados();
        },
        closeModalCadastro() {
            this.showModalCadastroForma = false;
        },
        cadastrado() {
            this.showModalCadastroForma = false;
            this.carregarDados();
            this.$root.showMessage('success', 'msg-sucesso-ao-adicionar-associacao');
        },
    },
};
</script>

<style lang="scss" scoped>
.aba-cliente {
    height: 100%;

    .botao-acao {
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }

    @media (max-width: 760px) {
        .search-bar {
            padding-bottom: 0.4rem;
        }

        .botao-acao {
            margin-top: 0;
        }
    }
}
</style>
